import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DropdownPosition } from '@ng-select/ng-select';

@Component({
  selector: 'form-select',
  template: `
    <div [ngClass]="applyPadding ? 'form-group' : ''">
      <label class="col-form-label font-weight-bold">{{label}}&nbsp;&nbsp;
        <i class="fas fa-info-circle text-primary input-icon-right cursor-pointer"
        [pTooltip]="infoMessage" *ngIf="infoMessage"></i></label>
      <ng-select [items]="items"
                 [bindValue]="valueFieldName" [bindLabel]="labelFieldName"
                 [loading]="loading"
                 [clearable]="clearable"
                 [placeholder]="placeholder"
                 [formControl]="control"
                 [dropdownPosition]="dropdownPosition ? dropdownPosition : 'auto'"
                 [appendTo]="appendToBody ? 'body' : null"
                 [hideSelected]="hideSelected"
                 (clear)="removedItem.emit()"
                 (change)="selectChanged.emit($event)">
      </ng-select>
      <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
    </div>
  `,
})
export class FormSelectComponent {

  @Input() control: AbstractControl;
  @Input() items: any[];
  @Input() labelFieldName = 'nome'; // di default label = campo "nome"
  @Input() valueFieldName = 'id'; // di default value = campo "id"
  @Input() label: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;
  @Input() loading: boolean;
  @Input() clearable = true;
  @Input() appendToBody;
  @Input() dropdownPosition: DropdownPosition;
  @Input() applyPadding = true; // se settata a false rimuove la classe "form-group"
  @Input() infoMessage: boolean; // messaggio di info da mostrare vicino alla label, opzionale
  @Input() hideSelected: boolean;

  @Output() selectChanged: EventEmitter<any> = new EventEmitter();
  @Output() removedItem: EventEmitter<void> = new EventEmitter();

}
